import { render, staticRenderFns } from "./TrainingUpsell.vue?vue&type=template&id=3f85bf49&scoped=true&"
import script from "./TrainingUpsell.vue?vue&type=script&lang=ts&"
export * from "./TrainingUpsell.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingUpsell.vue?vue&type=style&index=0&id=3f85bf49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f85bf49",
  null
  
)

export default component.exports